import { Modal } from 'bootstrap';
var demoConfigs = [
    {
        TITLE: "Enregistrement de la présentation offerte aux centres de services scolaires et commissions scolaires le 4 novembre 2022",
        VIDEOS: [
            {
                TITLE: "",
                TEXT: "",
                SRC: "documents/Presentation_Previsions_PPS_et_Module_Carto_20221104.mp4",
            },
        ]
    }
   
];

var demoContainerHTML = '<div class="modal fade" id="DemoModal" tabindex="-1" aria-hidden="true">' +
                                '<div class="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable">' +
                                    '<div class="modal-content">' +
                                        '<div class="modal-header">' +
                                            '<h1 class="modal-title fs-5">Webinaire - Prévisions effectifs scolaires PPS et module cartographique</h1>' +
                                            '<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>' +
                                        '</div>' +
                                        '<div class="modal-body">' +
                                        '<div class="accordion" id="DemoModal-accordion">' +
                                                _.map(demoConfigs, function(demoConfigs, idx){
                                                    return '<div class="accordion-item">' +
                                                                '<h2 class="accordion-header">' +
                                                                    '<button class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#DemoModal-accordion-' + idx + '" aria-expanded="true" aria-controls="DemoModal-accordion-' + idx + '">' + demoConfigs.TITLE + '</button>' +
                                                                '</h2>' +
                                                                '<div id="DemoModal-accordion-' + idx + '" class="accordion-collapse collapse show" data-bs-parent="#DemoModal-accordion">' +
                                                                    '<div class="accordion-body">' +
                                                                        '<div class="container-fluid">' +
                                                                            '<div class="row">' +
                                                                                _.map(demoConfigs.VIDEOS, function(videoConfigs){
                                                                                    return '<div class="col">' +
                                                                                                '<div>' +
                                                                                                    '<video class="card-img-top" controls src="' + videoConfigs.SRC + '"></video>' +
                                                                                                    '<div class="card-body">' +
                                                                                                        '<h5 class="card-title">' + videoConfigs.TITLE + '</h5>' +
                                                                                                        '<p class="card-text">' + videoConfigs.TEXT + '</p>' +
                                                                                                    '</div>' +
                                                                                                '</div>' +
                                                                                            '</div>';
                                                                                }).join("") +
                                                                            '</div>' +
                                                                        '</div>' +
                                                                    '</div>' +
                                                                '</div>' +
                                                            '</div>';
                                                    }).join("") +
                                            '</div>' +
                                        '</div>' +
                                        '<div class="modal-footer">' +
                                            '<button type="button" class="btn btn-primary" data-bs-dismiss="modal">Carte</button>' +
                                        '</div>' +
                                    '</div>' +
                                '</div>' +
                            '</div>';

export default class Demo {
    constructor(){
        $("body").append(demoContainerHTML);
        new Modal('#DemoModal');
    }
}